import React from 'react';
import TextInput from 'components/v2/Input/TextInput';
import { useIMask } from 'react-imask';
import type { FactoryOpts } from 'imask';

export type MaskedProps<Value = string> = {
  /** Pattern mask (e.g. `00:00`). Ignored when `imaskOptions` is set. */
  mask?: string;
  /** Full IMask options (e.g. `MaskedRange` blocks). Takes precedence over `mask`. */
  imaskOptions?: FactoryOpts;
  name?: string;
  label?: string;
  value?: string;
  error?: string;
  variant?: 'outlined' | 'filled' | 'standard';
  placeholderChar?: string;
  fullWidth?: boolean;
  onChange?: (event: any, value: Value) => void;
  onComplete?: (value: Value, maskRef: any, event?: any) => void;
};

const MaskedField: React.FC<MaskedProps> = (props) => {
  const {
    mask,
    imaskOptions,
    name,
    value,
    onChange,
    onComplete,
    error,
    fullWidth,
    placeholderChar = 'X',
  } = props;

  if (!imaskOptions && !mask) {
    throw new Error('MaskedTextField requires "mask" or "imaskOptions".');
  }

  const imaskOpts: FactoryOpts = imaskOptions
    ? { lazy: false, ...imaskOptions, placeholderChar }
    : { mask: mask as string, lazy: false, placeholderChar };

  const { ref } = useIMask(imaskOpts, {
    onAccept: (value: string, ref: any, event: any) => {
      onChange && onChange(event, value);
    },
    onComplete,
    defaultUnmaskedValue: value,
  });

  return (
    <TextInput name={name} ref={ref} error={error} fullWidth={fullWidth} />
  );
};

export default MaskedField;
